export const ERROR_TYPES = {
  SDK_ERROR: {
    CODE: 110001,
    NAME: 'SDK_ERROR',
    MESSAGE: 'SDK_ERROR'
  },
  UNKNOWN: {
    CODE: 110002,
    NAME: 'UNKNOWN_ERROR',
    MESSAGE: 'UNKNOWN_ERROR'
  },
  FAILED_ACTION: {
    CODE: 110003,
    NAME: 'FAILED_ACTION',
    MESSAGE: 'FAILED_ACTION'
  },
  INVALID_PARAMETER: {
    CODE: 110004,
    NAME: 'INVALID_PARAMETER',
    MESSAGE: 'INVALID_PARAMETER'
  },
}

export default { ERROR_TYPES }